export default function AdvantagesSection() {
  const advantages = [
    {
      icon: "ri-user-star-line",
      title: "Assessoria Personalizada",
      description:
        "Consultores especializados acompanham você em cada etapa, desde a simulação até a aprovação do crédito.",
    },
    {
      icon: "ri-percent-line",
      title: "Taxas Competitivas",
      description:
        "Parcerias com os principais bancos garantem as melhores taxas do mercado para financiamento e Home Equity.",
    },
    {
      icon: "ri-time-line",
      title: "Aprovação Ágil",
      description:
        "Processo simplificado e rápido. Análise de crédito em tempo recorde para você não perder oportunidades.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Segurança e Transparência",
      description:
        "Todas as informações são claras desde o início. Sem taxas ocultas, sem surpresas no caminho.",
    },
    {
      icon: "ri-building-line",
      title: "Parcerias Estratégicas",
      description:
        "Trabalhamos com corretores e imobiliárias oferecendo condições exclusivas para seus clientes.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Atendimento Diferenciado",
      description:
        "Suporte via WhatsApp, telefone e e-mail. Sempre prontos para tirar suas dúvidas e ajudar.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start mb-12 md:mb-16">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              Por que escolher a RCRED
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Vantagens e
              <br />
              Diferenciais
            </h2>
          </div>
          <div className="lg:pt-10">
            <p className="text-foreground-600 leading-relaxed">
              Nosso compromisso é oferecer a melhor experiência em crédito imobiliário.
              Combinamos expertise financeira, tecnologia e atendimento humano para
              entregar resultados que superam expectativas.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {advantages.map((item, index) => (
            <div
              key={index}
              className="group p-6 bg-background-100 rounded-2xl border border-background-200 hover:border-primary-300 transition-all duration-300 hover:bg-background-50"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}